const Switch = (props) => {
  const { test, children } = props;
  return children.find((child) => {
    return child.props.flag === test;
  });
};

export default Switch;
